import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-input-single-line",
  "use": "foquz-icon-input-single-line-usage",
  "viewBox": "0 0 26 10",
  "content": "<symbol viewBox=\"0 0 26 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-input-single-line\"><path d=\"M4 5h14M3 9h20a2 2 0 002-2V3a2 2 0 00-2-2H3a2 2 0 00-2 2v4a2 2 0 002 2z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol